﻿import {AccountSummaryViewModel} from './accountSummary.viewmodel';
import * as Repositories from '../../repositories/repositories'
import * as Model from '../../models/models';
import * as _ from 'lodash';


export class AccountSummaryGateway {

    static $inject = [
        '$q', 'userRepository', 'policyholderRepository',
        'billingStatementRepository', 'submissionRepository', 'codeRepository', 'policyRepository'];

    constructor(
        private $q: ng.IQService,
        private userRepository: Repositories.UserRepository,
        private policyholderRepository: Repositories.PolicyholderRepository,
        private billingStatementRepository: Repositories.BillingStatementRepository,
        private submissionRepository: Repositories.SubmissionRepository,
        private codeRepository: Repositories.CodeRepository,
        private policyRepository: Repositories.PolicyRepository) {
    }


    public loadAccountSummaryViewModel = (accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {

        return this.userRepository.getUserProfile()
            .then((userProfile: Model.IUserProfile): AccountSummaryViewModel => {
                accountSummaryViewModel.userProfile = userProfile;
                return accountSummaryViewModel;
            })
            .then((accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
                return this.setPolicyholder(accountSummaryViewModel);
            })
            .then((accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
                return this.setSubmissions(accountSummaryViewModel);
            })
            .then((accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
                return this.setSubmissionStatus(accountSummaryViewModel);
            })
            .then((accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
                return this.setPolicies(accountSummaryViewModel);
            }) 
            .then((accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
               
                if(accountSummaryViewModel.isSubmissionStatusBound()){
                    return this.setBillingStatement(accountSummaryViewModel);
                }
                else
                {
                    return this.$q.when(accountSummaryViewModel);
                }
                 
            });

    }

    private setPolicyholder = (accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
        return this.policyholderRepository.getPolicyholdersByUserId(accountSummaryViewModel.userProfile.id)
            .then((policyholder: Model.IPolicyholder) => {
                accountSummaryViewModel.policyholder = policyholder;
                return accountSummaryViewModel;
            });
    }

    private setSubmissions = (accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
        return this.submissionRepository.getSubmissionsByPolicyholderId(accountSummaryViewModel.policyholder.id)
            .then((submissions: Array<Model.ISubmission>) => {
                accountSummaryViewModel.submissions = submissions;
                return accountSummaryViewModel;
            });
    }

    private setBillingStatement = (accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {

        return this.billingStatementRepository.getBillingStatementByPolicyHolderId(accountSummaryViewModel.policyholder.id,true)
            .then((billingStatement: Model.IBillingStatement) => {
                accountSummaryViewModel.billingStatement = billingStatement;
                return accountSummaryViewModel;
            })
            .catch(() => {
                //swallowing the exception and showing custom div when BillingStatement not available
                return this.$q.when(accountSummaryViewModel);
              
            });
    }
   
    private setSubmissionStatus = (accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
        return this.codeRepository.getById(accountSummaryViewModel.submissions[0].statusCId)
            .then((status: Model.ICode) => {
                accountSummaryViewModel.submissionStatus = status.codeName;
                return accountSummaryViewModel;
            });
    }

    private setPolicies = (accountSummaryViewModel: AccountSummaryViewModel): ng.IPromise<AccountSummaryViewModel> => {
        return this.policyRepository.getPoliciesBySubmissionId(accountSummaryViewModel.submissions[0].id)
            .then((policies: Array<Model.IPolicy>) => {
                accountSummaryViewModel.policies = policies;
                return accountSummaryViewModel;
            });
    }

}